import { Link } from "react-router-dom";
import backFlourish from "../assets/images/icons/back-flourish.svg";
import checkIcon from "../assets/images/icons/check.svg";
import nextDouble from "../assets/images/icons/next-double.svg";
import { useTranslation } from "./Localization";
import { resolveTourPath, useTourMode } from "./TourMode";

type ControlsProps = {
  backTo: string;
  nextTo: string;
  check?: boolean;
  nextDisabled?: boolean;
  onNext?: () => void;
};

export default function Controls({
  backTo,
  nextTo,
  check = false,
  nextDisabled = false,
  onNext,
}: ControlsProps) {
  const { t } = useTranslation();
  const { interactive } = useTourMode();
  const resolvedBackTo = resolveTourPath(backTo, -1, interactive);
  const resolvedNextTo = resolveTourPath(nextTo, 1, interactive);
  const nextIcon = check
    ? <img className="check-icon" src={checkIcon} alt="" />
    : <img className="next-icon" src={nextDouble} alt="" />;

  return (
    <nav className="controls" aria-label={t("accessibility.navigation")}>
      <Link to={resolvedBackTo} aria-label={t("common.back")}>
        <img src={backFlourish} alt="" />
      </Link>
      {onNext
        ? <button type="button" className="control-pending" onClick={onNext} aria-label={check ? t("common.done") : t("common.next")}>{nextIcon}</button>
        : nextDisabled
        ? <button type="button" className="control-disabled" disabled aria-label={check ? t("common.done") : t("common.next")}>{nextIcon}</button>
        : <Link to={resolvedNextTo} aria-label={check ? t("common.done") : t("common.next")}>{nextIcon}</Link>}
    </nav>
  );
}
